import useSWR from "swr";
import axios from "axios";

function useActiveUser({ shouldFetch = true, token }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/auth/me`, token] : null, async ([url]) => {
    const { data: user } = await axios.get(url);

    return { user };
  });
}

export default useActiveUser;
